export default "__VITE_ASSET__7HjtXeCk__"